module.exports = __webpack_public_path__ + "static/img/DeccanChronicle_Logo.6e92045b.jpg";